import { YOO_FINDS_CDN } from "@/common";
const basePcUrl = `${YOO_FINDS_CDN}/pc/holiday/easter`;

export const EASTER_RANK_BANNER = `${basePcUrl}/easter-banner.webp`;
export const EASTER_FINDS = `${basePcUrl}/easter-finds.webp`;
